module.exports = __webpack_public_path__ + "static/media/icon_internet.b0d909a6.svg";